/*
 * Copyright (C) 2025 JPMorgan Chase & Company
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, is not permitted.
 */

import {ExdsIconClock} from '@exds/icons';
import {ExdsText} from '@exds/core';
import './ExpiredQr.scss';

export default function ExpiredQr() {
  return (
    <>
      <ExdsIconClock className="expired-qr icon" />
      <ExdsText className="text-expired-qr">Your unique QR code has expired.</ExdsText>
    </>
  );
}
